import { isFileUploadSessionExpired } from 'models';
import { mappedConst } from 'shared';
import { FileUploadState, FILE_UPLOAD_SESSION_STATE_TYPE } from 'store';

type VerifyFileUploadStatePayload = {
  fileUploadState: FileUploadState;
};

type ResultType = 'ok' | 'error';
export const VERIFY_FILE_UPLOAD_STATE_RESULT_TYPE: mappedConst<ResultType> = {
  ok: 'ok',
  error: 'error',
};

type ResultOK = {
  type: Extract<ResultType, 'ok'>;
};

type ResultError = {
  type: Extract<ResultType, 'error'>;
  errorMessage: string;
  unrecoverable: boolean;
};

type Result = ResultOK | ResultError;

export const verifyFileUploadState = ({
  fileUploadState,
}: VerifyFileUploadStatePayload): Result => {
  const { setting, session } = fileUploadState;
  if (setting == null) {
    return {
      type: VERIFY_FILE_UPLOAD_STATE_RESULT_TYPE.ok,
    };
  }
  const { errorMessages } = setting;
  if (session.type === FILE_UPLOAD_SESSION_STATE_TYPE.error) {
    return {
      type: VERIFY_FILE_UPLOAD_STATE_RESULT_TYPE.error,
      errorMessage: session.errorMessage,
      unrecoverable: true,
    };
  }
  if (session.type === FILE_UPLOAD_SESSION_STATE_TYPE.notReady) {
    return {
      type: VERIFY_FILE_UPLOAD_STATE_RESULT_TYPE.error,
      errorMessage: errorMessages.ERROR,
      unrecoverable: false,
    };
  }

  const expired = isFileUploadSessionExpired(session);
  if (expired) {
    return {
      type: VERIFY_FILE_UPLOAD_STATE_RESULT_TYPE.error,
      errorMessage: errorMessages.API_ACCESS_DENIED,
      unrecoverable: true,
    };
  }
  return {
    type: VERIFY_FILE_UPLOAD_STATE_RESULT_TYPE.ok,
  };
};
